import { render, staticRenderFns } from "./InstructionTypeIndex.vue?vue&type=template&id=4d9cf6cf&"
import script from "./InstructionTypeIndex.vue?vue&type=script&lang=js&"
export * from "./InstructionTypeIndex.vue?vue&type=script&lang=js&"
import style0 from "./InstructionTypeIndex.vue?vue&type=style&index=0&id=4d9cf6cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports